<template>
  <a-card :bordered="false" class="card-area">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="客户单号" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                placeholder="请输入客户单号"
                v-model="queryParam.orderNo"
                style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="尾程运单号" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                placeholder="请输入尾程运单号"
                v-model="queryParam.waybillNumber"
                style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="产品代码" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                placeholder="请输入产品代码"
                v-model="queryParam.productCode"
                style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item label="收件人姓名" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                placeholder="请输入收件人姓名"
                v-model="queryParam.consigneeName"
                style="width: 100%"/>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="收件人电话" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                  placeholder="请输入收件人电话"
                  v-model="queryParam.consigneeMobile"
                  style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="收件人国家" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                  placeholder="请输入收件人国家"
                  v-model="queryParam.consigneeCountry"
                  style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="收件人邮编" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                  placeholder="请输入收件人邮编"
                  v-model="queryParam.consigneeZipCode"
                  style="width: 100%"/>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
<!--      <div style="flex: 1;">-->
<!--        <a-button type="primary" icon="download" @click="handleExport()" style="margin-right: 8px;">-->
<!--          导出-->
<!--        </a-button>-->
<!--      </div>-->

      <div style="flex: 1; text-align: right;">
        <a-button type="primary" icon="search" @click="handleSearchQuery()" style="margin-right: 8px;">
          查询
        </a-button>
        <a-button icon="reload" @click="handleSearchReset()" style="margin-right: 8px;">
          重置
        </a-button>
        <a @click="handleToggleSearch">
          {{ toggleSearchStatus ? '收起' : '展开' }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
        </a>
      </div>
    </div>

    <!-- table区域 -->
    <div>
      <a-table ref="table" size="middle" bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               @change="handleTableChange"
               :scroll="{ x: tableScrollX }"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">查看详情</a>
        </span>
      </a-table>

      <!-- 详情抽屉 -->
      <a-drawer title="内部订单详情" placement="right" :closable="true" :destroyOnClose="true" :width="1200"
                :bodyStyle="{ backgroundColor: '#f0f2f5' }" :visible="drawerVisible"
                @close="onDrawerClose">
        <InnerOrderDetail :orderData="orderDetailData" :goodsList="goodsList" ref="orderDetail"></InnerOrderDetail>
      </a-drawer>
    </div>
  </a-card>
</template>

<script>
import { innerOrderDetail } from '@/api/innerOrder'
import InnerOrderDetail from './modules/InnerOrderDetail'
import { TableListMixin } from '@/situation/mixins/tableListMixin'
import { AsyncExportMixin } from '@/mixins/asyncExportMixin'

export default {
  name: 'InnerOrder',
  mixins: [TableListMixin, AsyncExportMixin],
  components: {
    InnerOrderDetail
  },
  computed: {
    tableScrollX() {
      // 计算所有列宽之和
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    }
  },
  data() {
    return {
      description: '内部订单管理页面',
      // 查询条件
      queryParam: {
        orderNo: '',
        waybillNumber: '',
        productCode: '',
        consigneeName: '',
        consigneeMobile: '',
        consigneeCountry: '',
        consigneeZipCode: ''
      },
      // 表格列配置
      columns: [
        {
          title: '客户单号',
          align: 'center',
          dataIndex: 'orderNo',
          fixed: 'left',
          width: 150
        },
        {
          title: '尾程运单号',
          align: 'center',
          dataIndex: 'waybillNumber',
          width: 180
        },
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'productCodeName',
          width: 150
        },
        {
          title: '重量(kg)',
          align: 'center',
          dataIndex: 'weight',
          width: 100,
          customRender: (text) => {
            return text ? text + ' kg' : '-'
          }
        },
        {
          title: '长(cm)',
          align: 'center',
          dataIndex: 'length',
          width: 80,
          customRender: (text) => {
            return text ? text + ' cm' : '-'
          }
        },
        {
          title: '宽(cm)',
          align: 'center',
          dataIndex: 'width',
          width: 80,
          customRender: (text) => {
            return text ? text + ' cm' : '-'
          }
        },
        {
          title: '高(cm)',
          align: 'center',
          dataIndex: 'height',
          width: 80,
          customRender: (text) => {
            return text ? text + ' cm' : '-'
          }
        },
        {
          title: '收件人姓名',
          align: 'center',
          dataIndex: 'consigneeName',
          width: 120
        },
        {
          title: '收件人电话',
          align: 'center',
          dataIndex: 'consigneeMobile',
          width: 150
        },
        {
          title: '收件人邮箱',
          align: 'center',
          dataIndex: 'consigneeEmail',
          width: 160
        },
        {
          title: '收件人国家',
          align: 'center',
          dataIndex: 'consigneeCountry',
          width: 120
        },
        {
          title: '收件人邮编',
          align: 'center',
          dataIndex: 'consigneeZipCode',
          width: 120
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      drawerVisible: false,
      orderDetailData: {},
      goodsList: [],
      // API配置
      url: {
        selectData: "/ndt/innerOrder/page",
        exportXlsUrl: "/ndt/innerOrder/export",
        exportTaskUrl: "/ndt/export/task/innerOrder/async",
        exportStatusUrl: "/ndt/export/task/status",
        exportDownloadUrl: "ndt/export/task/download"
      }
    }
  },
  methods: {
    // 初始化字典配置（TableListMixin要求的方法）
    initDictConfig() {
      // 如果需要字典配置，在这里初始化
    },
    // 查询方法（使用mixin的searchQuery）
    handleSearchQuery() {
      this.searchQuery()
    },
    // 重置方法（使用mixin的searchReset）
    handleSearchReset() {
      this.searchReset()
    },
    // 导出方法（使用mixin的handleExportXls2）
    handleExport() {
      this.handleExportXls2()
    },
    // 查看详情
    handleDetail(record) {
      this.orderDetailData = record
      // 获取订单详情
      innerOrderDetail(record.id).then(res => {
        if (res.code == '200') {
          this.orderDetailData = res.data
          this.goodsList = res.data.goodsList
        }
      })
      // 获取物品列表
      // innerOrderGoodsList({ orderId: record.id }).then(res => {
      //   if (res.code == '200') {
      //     this.goodsList = res.data
      //   }
      // })
      this.drawerVisible = true
    },
    // 关闭抽屉
    onDrawerClose() {
      this.drawerVisible = false
      this.orderDetailData = {}
      this.goodsList = []
    }
  }
}
</script>

<style scoped>
.card-area {
  margin: 10px;
}

.table-page-search-wrapper {
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}

.table-operator {
  //padding: 0 20px;
  margin-bottom: 15px;
}
</style>
